"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarCreationRequest = void 0;
const solarConstants_1 = require("../constants/solarConstants");
class SolarCreationRequest {
    constructor() {
        this.solarConstants = new solarConstants_1.SolarConstants();
    }
}
exports.SolarCreationRequest = SolarCreationRequest;
